import React from 'react';

const CheckboxFilter = ({ onHouseStyleChange, value, label, checked }) => (
  <li className="search-filters__drop-item">
    <input type="checkbox" name="houseStyles" checked={checked} onChange={onHouseStyleChange} className="search-filters__checkbox" value={value} />
    <label className="search-filters__item-label">{label}</label>
  </li>
);

export default CheckboxFilter;